import { NgIcon, provideIcons } from '@ng-icons/core';
import { matCheckCircle, matCircle } from '@ng-icons/material-icons/baseline';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  imports: [NgIcon, TranslateModule],
  viewProviders: [provideIcons({ matCheckCircle, matCircle })],
})
export class PasswordStrengthComponent {
  @Input() password = '';

  get hasMinimumLength(): boolean {
    return this.password?.length >= 8;
  }

  get hasLowerCase(): boolean {
    return /[a-z]/.test(this.password || '');
  }

  get hasUpperCase(): boolean {
    return /[A-Z]/.test(this.password || '');
  }

  get hasDigit(): boolean {
    return /\d/.test(this.password || '');
  }

  get hasSpecialChar(): boolean {
    return /[#$^+=!*()@%&.,_<>-]/.test(this.password || '');
  }
}
